/**
 * The paging vocabulary, in a file with NO IMPORTS.
 *
 * ┌─ ⛔ WHY IT IS NOT IN `contact-list.ts`, WHICH IS WHERE IT WAS FOR AN HOUR ──┐
 * │ The contacts list component needs `ROWS_PER_PAGE` to render the control and │
 * │ `parseRowsPerPage` to read the URL. Importing them from `contact-list.ts`   │
 * │ works, typechecks, and **took the Postgres driver into the browser bundle**: │
 * │                                                                            │
 * │   98 modules  → 225 modules                                                 │
 * │   299 kB      → 410 kB  (127 kB gzipped, up from 90)                       │
 * │                                                                            │
 * │ Vite said so in as many words - *"Module 'crypto' has been externalized for  │
 * │ browser compatibility, imported by node_modules/postgres/src/connection.js"* │
 * │ - and the build still SUCCEEDED, which is why the size was the signal.      │
 * └────────────────────────────────────────────────────────────────────────────┘
 *
 * ⛔ AND THE REASON IT HAD NOT HAPPENED BEFORE IS THE DIFFERENCE BETWEEN A TYPE
 * IMPORT AND A VALUE IMPORT. `web/` already imports `ContactListRow`,
 * `ThreadMessage` and `ConversationPanel` from `src/services/` - all of them
 * `import type`, which TypeScript ERASES, so no module graph is created. A
 * VALUE crosses the boundary for real and brings everything the file imports
 * with it.
 *
 * ⚠️ SO THE RULE IS: A CONSTANT SHARED WITH THE CLIENT LIVES IN A FILE THAT
 * IMPORTS NOTHING. That is cheap to honour and the failure it prevents is
 * invisible - a working build, a passing suite, and a frontend carrying a
 * database driver it can never use.
 */

/**
 * ⛔ THE ROWS-PER-PAGE VOCABULARY. Amir 2026-09-12, and it is ONE SETTING FOR
 * EVERY LIST VIEW rather than a per-list preference.
 *
 * ⚠️ A CLOSED LIST RATHER THAN A NUMBER, for the reason `SORTS` is a closed
 * list: the value arrives from a query string, and an arbitrary one is a caller
 * choosing how much work the server does. 500 is already the point where the
 * deepest OFFSET and the capped count both start to matter.
 */
export const ROWS_PER_PAGE = [25, 50, 100, 200, 500] as const

/** The default, and the size every list used before the control existed. */
export const CONTACT_PAGE_SIZE = 50

/** ⚠️ Falls back rather than erroring, like `parseSort` and `parseView`: a typo
 *  in a pasted link shows the default page rather than a 400. */
export function parseRowsPerPage(raw: string | number | undefined): number {
  const n = Number(raw)
  return (ROWS_PER_PAGE as readonly number[]).includes(n) ? n : CONTACT_PAGE_SIZE
}

/**
 * ⛔ HOW DEEP A TOTAL COUNTS BEFORE IT REPORTS A FLOOR. Beyond this the list
 * says "10,000+", which is an honest answer where a number that took a second to
 * produce is not a better one.
 *
 * ⛔ MOVED HERE FROM `contact-list.ts` WHEN THE BOOKINGS LIST NEEDED IT, which is
 * the moment a per-surface constant becomes a per-product one. ⚠️ The measured
 * argument for the VALUE stays in `contact-list.ts` beside the numbers it was
 * measured from: 40ms unfiltered at 10,000, and 151ms for a filter matching
 * twelve rows out of 300,000 - the case a cap does NOT make cheap, because a
 * filter has to examine every row to know how few match.
 *
 * ⚠️ AND TWO LISTS WITH TWO CAPS WOULD HAVE BEEN TWO ANSWERS TO "how many is too
 * many to count", drifting apart the first time one was tuned.
 */
export const COUNT_CAP = 10_000
